<template>
  <Spinner v-if="loadingStatus" text="Retrieving data..." classes="text-dark-8 mh-60" spinner-color="var(--c-dark-8)" spinner-size="15px" />
  <div v-else-if="dynamicPlayerFeatures && (hasLiveSubscription && hasLiveSubscription.enabled || hasVodSubscription && hasVodSubscription.enabled)" class="container page-title-area">
    <header class="title d-flex justify-content-between align-items-center">
      <h1 class="page-title mb-3 mt-5">Dynamic Player</h1>
    </header>
    <section class="text-center mt-100">
      <h2 class="text-dark-8 text-s-l text-500">Multiple sources, one player</h2>
      <p class="text-s-m text-dark-6 mb-2">Learn more about how it works <a target="_blank" class="text-reset text-underline" href="https://docs.castr.com/en/articles/7785953-how-to-create-a-dynamic-player">here</a>.</p>
      <div class="d-flex flex-column mw-225 mx-auto">
							<b-button class="mb-2" target="_blank" variant="outline-secondary" size="lg"  v-b-modal.modal-demo-video>
								<svg class="mr-2" xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.50002 1.6499H5.47423C4.79604 1.6499 4.25057 1.64989 3.80917 1.68596C3.35519 1.72305 2.95872 1.80126 2.59265 1.98778C2.00935 2.28499 1.53511 2.75923 1.2379 3.34253C1.05138 3.7086 0.97317 4.10506 0.936078 4.55905C0.900014 5.00045 0.900019 5.54592 0.900025 6.22411V6.2499V9.7499V9.7757C0.900019 10.4539 0.900014 10.9994 0.936078 11.4408C0.97317 11.8947 1.05138 12.2912 1.2379 12.6573C1.53511 13.2406 2.00935 13.7148 2.59265 14.012C2.95872 14.1985 3.35519 14.2768 3.80917 14.3138C4.25057 14.3499 4.79605 14.3499 5.47423 14.3499H5.47424H5.50002H11.5H11.5258H11.5258C12.204 14.3499 12.7495 14.3499 13.1909 14.3138C13.6449 14.2768 14.0413 14.1985 14.4074 14.012C14.9907 13.7148 15.4649 13.2406 15.7621 12.6573C15.9487 12.2912 16.0269 11.8947 16.064 11.4408C16.1 10.9994 16.1 10.4539 16.1 9.77569V9.77568V9.7499V6.2499V6.22412V6.22411C16.1 5.54593 16.1 5.00045 16.064 4.55905C16.0269 4.10506 15.9487 3.7086 15.7621 3.34253C15.4649 2.75923 14.9907 2.28499 14.4074 1.98778C14.0413 1.80126 13.6449 1.72305 13.1909 1.68596C12.7495 1.64989 12.204 1.6499 11.5258 1.6499H11.5H5.50002ZM3.13744 3.05699C3.30615 2.97103 3.52711 2.913 3.90689 2.88197C4.29367 2.85037 4.79006 2.8499 5.50002 2.8499H11.5C12.21 2.8499 12.7064 2.85037 13.0932 2.88197C13.4729 2.913 13.6939 2.97103 13.8626 3.05699C14.2201 3.23915 14.5108 3.52981 14.6929 3.88732C14.7789 4.05603 14.8369 4.27699 14.868 4.65677C14.8996 5.04355 14.9 5.53994 14.9 6.2499V9.7499C14.9 10.4599 14.8996 10.9563 14.868 11.343C14.8369 11.7228 14.7789 11.9438 14.6929 12.1125C14.5108 12.47 14.2201 12.7607 13.8626 12.9428C13.6939 13.0288 13.4729 13.0868 13.0932 13.1178C12.7064 13.1494 12.21 13.1499 11.5 13.1499H5.50002C4.79006 13.1499 4.29367 13.1494 3.90689 13.1178C3.52711 13.0868 3.30615 13.0288 3.13744 12.9428C2.77993 12.7607 2.48927 12.47 2.30711 12.1125C2.22115 11.9438 2.16312 11.7228 2.13209 11.343C2.10049 10.9563 2.10002 10.4599 2.10002 9.7499V6.2499C2.10002 5.53994 2.10049 5.04355 2.13209 4.65677C2.16312 4.27699 2.22115 4.05603 2.30711 3.88732C2.48927 3.52981 2.77993 3.23915 3.13744 3.05699ZM10.747 7.9999L7.10003 9.98918V6.01063L10.747 7.9999ZM7.52676 4.87649C6.79375 4.47666 5.90003 5.00721 5.90003 5.84217V10.1576C5.90003 10.9926 6.79375 11.5231 7.52676 11.1233L11.4826 8.96559C12.247 8.54867 12.2469 7.45114 11.4826 7.03422L7.52676 4.87649Z" fill="#8794B5"/>
              </svg>
							Dynamic Players Demo
							</b-button>
      <b-button
        size="md"
        variant="primary"
        v-b-modal="'modal-add-dynamic-player'"
      >
      <svg class="mr-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.9999 0.899902C7.33127 0.899902 7.5999 1.16853 7.5999 1.4999V6.3999H12.4999C12.8313 6.3999 13.0999 6.66853 13.0999 6.9999C13.0999 7.33127 12.8313 7.5999 12.4999 7.5999H7.5999V12.4999C7.5999 12.8313 7.33127 13.0999 6.9999 13.0999C6.66853 13.0999 6.3999 12.8313 6.3999 12.4999V7.5999H1.4999C1.16853 7.5999 0.899902 7.33127 0.899902 6.9999C0.899902 6.66853 1.16853 6.3999 1.4999 6.3999H6.3999V1.4999C6.3999 1.16853 6.66853 0.899902 6.9999 0.899902Z" fill="white"/>
      </svg>
        New Player
      </b-button>
      </div>
    </section>
    <add-dynamic-player-modal @player-added="onNewPlayer" />
    <demo-video-modal videoid="9UJ1aZUoaRqiJ86YfFYKG" />
  </div>
  <div class="container page-title-area" v-else>
    <header class="title d-flex justify-content-between align-items-center">
      <h1 class="page-title mb-3 mt-5">Dynamic Player</h1>
    </header>
    <section class="text-center mt-100 text-dark-6">
      <h2 class="text-dark-8 text-s-m text-500">Dynamic Player can play both livestreams and VOD content</h2>
      <p class="text-s-s text-dark-6 mb-4">Simply switch the source and your content will be played.</p>
      <a target="_blank" href="https://docs.castr.com/en/articles/7785953-how-to-create-a-dynamic-player" class="text-s-s d-flex justify-content-center mb-2 text-reset">
        <svg class="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M1.4999 1.90039C1.16853 1.90039 0.899902 2.16902 0.899902 2.50039V12.5004C0.899902 12.8318 1.16853 13.1004 1.4999 13.1004H5.7499C6.66117 13.1004 7.3999 13.8391 7.3999 14.7504V15.0004C7.3999 15.3318 7.66853 15.6004 7.9999 15.6004C8.04132 15.6004 8.08176 15.5962 8.12082 15.5882C8.39423 15.5323 8.5999 15.2903 8.5999 15.0004V14.7504C8.5999 13.8391 9.33863 13.1004 10.2499 13.1004H14.4999C14.8313 13.1004 15.0999 12.8318 15.0999 12.5004V2.50039C15.0999 2.16902 14.8313 1.90039 14.4999 1.90039H10.4999C9.47379 1.90039 8.56413 2.39893 7.9999 3.16701C7.43568 2.39893 6.52601 1.90039 5.4999 1.90039H1.4999ZM8.5999 5.00039L8.5999 12.4263C9.06554 12.0951 9.63498 11.9004 10.2499 11.9004H13.8999V3.10039H10.4999C9.45056 3.10039 8.5999 3.95105 8.5999 5.00039ZM7.3999 5.00039C7.3999 3.95105 6.54924 3.10039 5.4999 3.10039H2.0999V11.9004H5.7499C6.36483 11.9004 6.93426 12.0951 7.3999 12.4263V5.00039Z" fill="currentColor" fill-opacity="0.5"/>
        </svg>
        How Dynamic Player works.
      </a>
      <p v-b-modal.modal_tutorial class="text-s-s text-dark-6 d-flex justify-content-center hovered">
        <svg class="mr-2" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6.98597 3.65906L10.6171 5.62591C12.3187 6.54763 13.1695 7.0085 13.3161 7.68016C13.3621 7.89091 13.3621 8.10909 13.3161 8.31984C13.1695 8.9915 12.3187 9.45237 10.6171 10.3741L6.98597 12.3409C5.41916 13.1896 4.63576 13.614 4.01328 13.4004C3.81704 13.3331 3.6369 13.2258 3.48425 13.0853C3 12.6397 3 11.7487 3 9.96685V6.03315C3 4.25126 3 3.36032 3.48425 2.91468C3.6369 2.77419 3.81704 2.6669 4.01328 2.59958C4.63576 2.38604 5.41916 2.81038 6.98597 3.65906Z" stroke="currentColor" stroke-opacity="0.5" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Watch how Dynamic Player works.
      </p>
      <b-button
        size="md"
        variant="primary"
        to="/subscribe"
      >
        Upgrade Plan
      </b-button>
      <b-modal modal-class="modal_tutorial" id="modal_tutorial" centered>
        <iframe src="https://www.youtube.com/embed/ouEzsml7whU" title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen></iframe>
      </b-modal>
    </section>
  </div>
</template>

<script>
import Spinner from "@/components/ui/Spinner.vue";
import DemoVideoModal from '@/components/modals/DemoVideoModal.vue';
import { mapGetters } from 'vuex';

import AddDynamicPlayerModal from "@/components/modals/AddDynamicPlayerModal.vue"

export default {
  name: "DynamicDashboard",
  components: {
    Spinner,
		DemoVideoModal,
    AddDynamicPlayerModal
  },
  data() {
    return {
      
    };
  },
  computed: {
    ...mapGetters({
			loadingStatus: "Ui/loadingStatus",
      dynamicPlayerFeatures: "User/dynamicPlayerFeatures",
      hasLiveSubscription: "User/hasLiveSubscription",
      hasVodSubscription: "User/hasVodSubscription",
		}),
  },
  watch:{   
  },
  async mounted() {
    this.$store.dispatch('Ui/setLoadingStatus', true);
    await this.$store.dispatch('DynamicPlayers/getPlayers');
    await this.$store.dispatch('User/loadUser');
    if (this.$store.state.DynamicPlayers.players.length > 0) {
      this.$store.dispatch('DynamicPlayers/setCurrentPlayer', this.$store.state.DynamicPlayers.players.at(-1)._id);
      this.$router.push({path: '/dynamic/' + this.$store.state.DynamicPlayers.players.at(-1)._id})
    }
    this.$store.dispatch('Ui/setLoadingStatus', false);
  },
  methods: {
    async onNewPlayer() {
      await this.$store.dispatch('DynamicPlayers/getPlayers');
      this.$router.push({path: '/dynamic/' + this.$store.state.DynamicPlayers.players.at(-1)._id})
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hovered:hover {
  text-decoration: underline;
}
</style>
